import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import faqUrl from '@/utils/urls/faqUrl';

import { colors } from '@/lib/analytics/colors';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';
import { url_faq_reach_impressions } from '@/lib/urls/faqUrls';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';
import { Trans } from '@/components/tools/translation';

export const totalPostsReachConfig = {
    name: 'kpi.instagram.posts_reach',
    id: 'posts_reach',
    tooltip: (
        <Trans
            i18nKey="analytics:kpi.instagram.tooltip_total_posts_reach"
            components={{
                LinkFaq: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                        className="text-icoBlue underline"
                        target="_blank"
                        href={faqUrl(url_faq_reach_impressions)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    ),
    icon: {
        name: 'reach',
        style: colors.purple
    },
    data_format: KPI_VALUE_CLASSIC,
    size: SIZE_33,
    type: 'kpi',
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    loader: DefaultLoader,
    orientation: ORIENTATION_VERTICAL,
    element: KPIDefault,
    new: {
        dateAdded: '2025-10-29'
    }
};
